import { useEffect, useState } from "react";
import DeleteModel from "../../Components/DeleteModel";
import { deleteItem, toggleStatus } from "../../utils/apiUtils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { checkImage, PlusButton, ToggleSwitch } from "../../helper/ImageFormat";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import Spinner from "../../Components/spinner";
import dateformate from "../../helper/DateFormate";
import { useNavigate } from "react-router-dom";
import ActionPermission from "../../Auth/ActionPermission";

const Payment = () => {
 const navigator = useNavigate();
 const [paymentdata, setpaymentdata] = useState([]);
 const [loading, setLoading] = useState(false);
 const [deleteItemId, setDeleteItemId] = useState(null);
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const datafetch = async () => {
  await fetchAllData(`/paymentmethod`, setpaymentdata, null, setLoading);
 };

 useEffect(() => {
  const fetchData = async () => {
   await datafetch();
  };
  fetchData();
 }, []);

 const confirmDelete = async () => {
  await deleteItem("Payment", deleteItemId, datafetch);
  setDeleteItemId(null);
  setDeleteModalOpen(false);
 };

 const handleStatusToggle = async (Payment) => {
  const data = await toggleStatus(
   "paymentmethod-status",
   Payment?.id,
   datafetch
  );
  if (Object.keys(data).length > 0) {
   setpaymentdata((prevpayment) =>
    prevpayment.map((curr) =>
     curr.id === Payment.id ? { ...curr, isActive: data?.isActive } : curr
    )
   );
  }
 };

 const handleAdd = () => {
  navigator("/add-payment-method");
 };

 const handleEditClick = (item) => {
  navigator("/add-payment-method", {
   state: item,
  });
 };

 const Tableheader = [
  "Image",
  "Name",
  "Charge",
  "Description",
  "Updated At",
  "Active",
  "Action",
 ];

 return (
  <>
   <div className="content-wrapper">
    <div className="page-header mt-5">
     <h3 className="custom-page-title">Payment Methods</h3>
    </div>

    <div
     className="d-flex justify-content-between mb-3"
     style={{
      background: "#fff",
      padding: "10px",
      marginTop: "-20px",
     }}
    >
     <div style={{ width: "100%" }}>
      <div style={{ float: "right" }}>
       <PlusButton handleAdd={handleAdd} module={"Payment Methods"} />
      </div>
     </div>
    </div>

    <div className="row" style={{ marginTop: "-10px" }}>
     <div className="col-md-12 grid-margin stretch-card">
      <div className="card">
       <div className="card-body">
        <div className="pb-20 table-responsive ">
         <table className="custom-table table table-striped" id="myTable">
          <thead>
           <tr>
            {Tableheader &&
             Tableheader.length > 0 &&
             Tableheader.map((item, index) => <th key={index}>{item}</th>)}
           </tr>
          </thead>
          <tbody>
           {loading ? (
            <tr>
             <td colSpan="7" className="text-center">
              <Spinner animation="border" />
             </td>
            </tr>
           ) : paymentdata.length > 0 ? (
            paymentdata.map((Payment, id) => (
             <tr key={id}>
              <td>{checkImage(Payment.image)}</td>
              <td>{Payment.name}</td>
              <td>{Payment.charge}</td>
              <td>{Payment.description}</td>
              <td>{dateformate(Payment.updatedAt)}</td>
              <td>
               <ToggleSwitch
                data={Payment}
                name="isActive"
                checked={Payment.isActive}
                handleStatusToggle={handleStatusToggle}
                module={"Payment Methods"}
               />
              </td>
              <td>

              <ActionPermission pageKey={"Payment Methods"} action="Update">
                 <OverlayTrigger
                 placement="top"
                 overlay={<Tooltip id="edit-tooltip">{"Edit"}</Tooltip>}
                >
                 <div
                  style={{
                   background: "rgba(255, 108, 47, 0.1)",
                   width: "30px",
                   padding: "5px",
                   borderRadius: "5px",
                  }}
                 >
                  <i
                   className={"fa-solid fa-pen-to-square"}
                   style={{
                    cursor: "pointer",
                    color: "rgb(38, 94, 215)",
                    padding: "5px",
                    fontSize: "18px",
                   }}
                   onClick={() => handleEditClick(Payment)}
                  />
                 </div>
                </OverlayTrigger>
              </ActionPermission>
               
              </td>
             </tr>
            ))
           ) : (
            <tr>
             <td colSpan="7" className="text-center">
              <h4>No data available</h4>
             </td>
            </tr>
           )}
          </tbody>
         </table>
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>

   <DeleteModel
    deleteModalOpen={deleteModalOpen}
    setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
    onConfirm={confirmDelete}
    itemName="Payment"
   />
  </>
 );
};

export default Payment;
